import { render } from "./Requests.vue?vue&type=template&id=37013720&scoped=true"
import script from "./Requests.vue?vue&type=script&lang=js"
export * from "./Requests.vue?vue&type=script&lang=js"

import "./Requests.vue?vue&type=style&index=0&id=37013720&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-37013720"

export default script